import React from 'react'
import { useLocation } from 'react-router-dom'

interface LocState { participantId?: string }

const ExternalSignupSuccessful: React.FC = () => {
  const location = useLocation<LocState>()
  const participantID = location.state?.participantId

  const copy = async (): Promise<void> => {
    if (participantID == null || participantID === '') return
    try {
      await navigator.clipboard.writeText(participantID)
    } catch {
      const id = document.createElement('textarea')
      id.value = participantID
      document.body.appendChild(id)
      id.select()
      document.execCommand('copy') // for older browsers
      document.body.removeChild(id)
    }
  }

  return (
    <div className='external-signup-successful'>
      <h1>Signed in successfully</h1>
      <p>Your Watch @ Heart account has been created.</p>

      {(participantID != null && participantID !== '') && (
        <div className='signup-table'>
          <h2>Watch @ Heart Participant ID</h2>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
            <code style={{ wordBreak: 'break-all' }}>{participantID}</code>
            <button
              type='button'
              onClick={() => { void copy() }}
              className='button-primary button-autowidth background-background text-primary-color text-medium waves-effect waves-light'
              style={{ marginRight: 0 }}
            >
              Copy
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default ExternalSignupSuccessful
